import React, { FC } from 'react';
import { StatusChipType, StatusChip } from '@beeline.com/bp-design-system';
import { useGenderIntl } from './translations/useGenderIntl';

interface Props {
  assignable: boolean;
}

export const GenderAssignable: FC<React.PropsWithChildren<Props>> = ({ assignable }) => {
  const intl = useGenderIntl();

  return (
    <StatusChip
      label={assignable ? intl.statusEnabled : intl.statusDisabled}
      type={getAssignableChipColor(assignable)}
    />
  );
};

const getAssignableChipColor = (assignable: boolean) => (assignable ? StatusChipType.LIGHT_GREEN : StatusChipType.GREY);
